import React, { useState, useEffect } from 'react';
import { useApi, identityApiRef,configApiRef, fetchApiRef , discoveryApiRef} from '@backstage/core-plugin-api';
import { InfoCard, Avatar } from '@backstage/core-components';
import { Typography, Box, Grid, IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
  UserSettingsAppearanceCard,
  UserSettingsIdentityCard,
} from '@backstage/plugin-user-settings';
import { maxWidth, minHeight, minWidth } from '@mui/system';

const CustomSignOutButton = () => {
    const identityApi = useApi(identityApiRef);
    const configApi = useApi(configApiRef);
    const discoveryApi = useApi(discoveryApiRef);
    const fetchApi = useApi(fetchApiRef);
    const [signOutConfig, setSignOutConfig] = useState<{ cognitoDomain?: string; clientId?: string }>({});
    const [profile, setProfile] = useState<{ displayName?: string; email?: string; picture?: string }>({});
    const [userEntityRef, setUserEntityRef] = useState<string>();

  useEffect(() => {
    const loadIdentity = async () => {
      const identity = await identityApi.getBackstageIdentity();
      setUserEntityRef(identity.userEntityRef);
  
      const profileInfo = await identityApi.getProfileInfo();
      setProfile(profileInfo);
    };
    loadIdentity();
  }, [identityApi]);
  // Menu state
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const baseUrl = await discoveryApi.getBaseUrl('user');
        const fetchresponse = await fetchApi.fetch(`${baseUrl}/signout-config`, {
          method: 'POST',
        });

        if (!fetchresponse.ok) {
          const errorText = await fetchresponse.text();
          throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
        }

        const response = await fetchresponse.json();

        setSignOutConfig({
          cognitoDomain: response.cognitoDomain,
          clientId: response.clientId,
        });
      } catch (error) {
        console.error('Fetch error in useEffect:', error);
      }
    };

    fetchConfig();
  }, [discoveryApi, fetchApi]);

  const handleLogout = async () => {
    handleMenuClose();
    await identityApi.signOut();
    const baseurl = configApi.getOptionalString('app.baseUrl');
    const cognitoDomain = signOutConfig.cognitoDomain;
    const clientId = signOutConfig.clientId;
    const postLogoutRedirect = baseurl;

    window.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${postLogoutRedirect}`;
  };

  return (
    <Grid container spacing={3} alignItems="stretch">
      {/* Profile Card - Full Width */}
      <Grid item xs={6} style={{ marginBottom: '10px' }} >
        <InfoCard title="Profile" style={{  }}>
          <Box display="flex"   justifyContent="space-between" style={{ flexDirection: "row"}} marginBottom='10px'>
            {/* Avatar + Text */}
            <Box display="flex"   >
              <Box style={{  width: 96,
                // height={60}
                flexShrink: 0,
                borderRadius: "100%" }}
               
              >
                <Avatar
                  displayName={    
                    profile.displayName ??
                    userEntityRef?.split('/').pop() ?? 'User'}
                  picture={profile?.picture}
                />
              </Box>
              <Box ml={2} style={{ display: "flex", flexDirection: "column", height: "195px" }} >
                <Typography variant="body1" noWrap>
                    {userEntityRef ?? 'user:unknown'}
                </Typography>
                {profile?.email && (
                    <Typography variant="body2" color="textSecondary" noWrap>
                    {profile.email}
                    </Typography>
                )}
                </Box>
            </Box>

            {/* 3-dot Menu */}
            <Box>
              <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                getContentAnchorEl={null} 
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
              </Menu>
            </Box>
          </Box>
        </InfoCard>
      </Grid>

      {/* Second Row: Appearance + Identity */}
      <Grid item xs={12} md={6} style={{  }}>
        <UserSettingsAppearanceCard  />
      </Grid>
      <Grid item xs={12} md={6} style={{  }}>
        <UserSettingsIdentityCard  />
      </Grid>
    </Grid>
  );
};

export default CustomSignOutButton;
